<template>
	<button type="button" class="subtask-count" :class="classAddons">
		{{ count }}
		<SuiIcon name="icon-subitems-16" />
	</button>
</template>

<script setup lang="ts">
import { type Task } from '@/generated/graphql';
import { SuiIcon } from '@developers/scoro-ui';
import { computed } from 'vue';

export type SubtaskCountProps = {
	count: Task['subtasksCount'];
	isDone?: boolean;
};

const props = defineProps<SubtaskCountProps>();

const classAddons = computed(() => ({
	'subtask-count--is-done': props.isDone,
}));
</script>

<style lang="scss">
.subtask-count {
	--sui-icon-fill: #{$neutral-60};

	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.5rem;

	&--is-done {
		--sui-icon-fill: #{$neutral-50};

		color: $neutral-70;
	}

	&:hover {
		--sui-icon-fill: #{$neutral-70};

		color: $brand-50;
	}
}
</style>
